<template>
  <b-container>
    <div class="d-flex flex-row justify-content-left py-3">
      <div id="startStrict">
        <button class="commandButton" id="start" @click="start">
          {{ startText }}
        </button>
        <button class="commandButton" id="strict" @click="handleStrict">
          STRICT
        </button>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center py-3">
      <div id="appColorButtons">
        <button
          class="colorButton red"
          id="red"
          @click="handleColorButton"
        ></button>
        <button
          class="colorButton green"
          id="green"
          @click="handleColorButton"
        ></button>
        <button
          class="colorButton blue"
          id="blue"
          @click="handleColorButton"
        ></button>
        <button
          class="colorButton yellow"
          id="yellow"
          @click="handleColorButton"
        ></button>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center py-3">
      <div id="counter">
        <h2>Counter</h2>
        <div id="counterDisplay">
          <span>{{ count }}</span>
          <span id="strictMarker" v-show="strict">strict</span>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Display_SimonGame",
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      count: "--",
      step: 0,
      restart: false,
      startText: "START",
      playerTurn: false,
      cpuSequence: [],
      playerSequence: [],
      strict: false
    };
  },
  methods: {
    handleChange(changeMade) {
      console.log(changeMade);
    },
    //HANDLE THE EVENT OF CLICKING A COLOR BUTTON
    handleColorButton: function(event) {
      if (this.playerTurn) {
        this.audioSignal(event.target.id);
        this.lightColorButton(event.target.id);
        this.playerSequence.push(event.target.id);
        if (this.compareSequence(this.step)) {
          this.step += 1;
          if (
            this.step >= this.cpuSequence.length &&
            this.cpuSequence.length < 20
          ) {
            this.playerTurn = false;
            setTimeout(() => {
              this.addCpuStep();
              this.playCpuSequence(this.cpuSequence);
              this.playerSequence = [];
              this.step = 0;
            }, 1250);
          }
        } else {
          this.playerTurn = false;
          let countMem = this.count;
          if (this.strict) {
            countMem = 1;
            this.cpuSequence = [];
            this.addCpuStep();
          }
          this.count = "ERR";
          setTimeout(() => {
            this.count = countMem;
            this.playCpuSequence(this.cpuSequence);
            this.playerSequence = [];
            this.step = 0;
          }, 1750);
        }
      }
    },
    //HANDLE THE START BUTTON EVENT
    start: function() {
      this.count = 0;
      this.step = 0;
      this.cpuSequence = [];
      this.playerSequence = [];
      this.startText = "RESTART";
      this.addCpuStep();
      this.playCpuSequence(this.cpuSequence);
    },

    //COMPARES CPU AND PLAYER SEQUENCES
    compareSequence: function(step) {
      let cpu = this.cpuSequence.slice();
      let player = this.playerSequence.slice();
      return cpu[step] === player[step];
    },

    //ADD A STEP TO CPU SEQUENCE
    addCpuStep: function() {
      switch (Math.floor(Math.random() * 4)) {
        case 0:
          this.cpuSequence.push("red");
          break;
        case 1:
          this.cpuSequence.push("green");
          break;
        case 2:
          this.cpuSequence.push("blue");
          break;
        case 3:
          this.cpuSequence.push("yellow");
          break;
      }
      this.count += 1;
    },

    //PLAYS CPU SEQUENCE
    playCpuSequence: function(sequence) {
      if (this.cpuSequence.length === 20) {
        this.playerTurn = false;
        this.count = "WIN";
      } else {
        for (let i = 0; i < sequence.length; i++) {
          setTimeout(() => {
            this.audioSignal(sequence[i]);
            this.lightColorButton(sequence[i]);
          }, 300 + i * 1000);
        }
        setTimeout(() => {
          this.playerTurn = true;
        }, 300 + sequence.length * 1000);
      }
    },

    //PLAYS THE AUDIO CORRESPONDING TO THE BUTTON
    audioSignal: function(color) {
      const redAudio = new Audio(
        "https://s3.amazonaws.com/freecodecamp/simonSound1.mp3"
      );
      const greenAudio = new Audio(
        "https://s3.amazonaws.com/freecodecamp/simonSound2.mp3"
      );
      const blueAudio = new Audio(
        "https://s3.amazonaws.com/freecodecamp/simonSound3.mp3"
      );
      const yellowAudio = new Audio(
        "https://s3.amazonaws.com/freecodecamp/simonSound4.mp3"
      );

      switch (color) {
        case "red":
          redAudio.play();
          break;
        case "green":
          greenAudio.play();
          break;
        case "blue":
          blueAudio.play();
          break;
        case "yellow":
          yellowAudio.play();
          break;
      }
    },

    //LIGHT UP THE TARGET BUTTON OF THE EVENT
    lightColorButton: function(color) {
      document.getElementById(color).classList.remove(color);
      document.getElementById(color).classList.add(color + "-active");
      setTimeout(() => {
        document.getElementById(color).classList.remove(color + "-active");
        document.getElementById(color).classList.add(color);
      }, 500);
    },

    handleStrict: function() {
      this.strict = !this.strict;
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Ultra");

body {
  display: flex;
  justify-content: center;
}

#app {
  margin-top: 50px;
  margin-bottom: 50px;
  padding: 32px;

  border: 2px solid #555;
  border-radius: 56px;

  background: #232526; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #414345,
    #232526
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #414345,
    #232526
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.simon-tag {
  text-align: center;
  font-size: 38px;
  font-weight: 100;
  margin-top: 0;
  font-family: "Ultra", serif;
  color: white;

  .simon-registred {
    font-size: 20px;
    position: relative;
    top: -12px;
    left: -10px;
  }
}

#appColorButtons {
  width: 300px;
  height: 300px;
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: auto auto;
  grid-gap: 16px;
}

.colorButton {
  border: 3px solid #333;
  border-radius: 150px;
  outline: none;
  cursor: pointer;
}

.red {
  background: #ff0000;
}
.red-active {
  background: #ff7f7f;
}
.green {
  background: #00db5f;
}
.green-active {
  background: #a0ffc9;
}
.blue {
  background: #1776d6;
}
.blue-active {
  background: #56aaff;
}
.yellow {
  background: #fed93f;
}
.yellow-active {
  background: #fff4c9;
}

#counter {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 8px;
  color: white;

  h2 {
    margin: 16px 0 8px;
  }
}
#counterDisplay {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100px;
  height: 60px;

  font-size: 2em;
  background: #222;
  color: red;
  border-radius: 16px;
}
#strictMarker {
  margin: 0;
  font-size: 0.4em;
}

#startStrict {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.commandButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 50px;
  margin: 0 8px;

  border: 3px solid #333;
  border-radius: 16px;

  outline: none;
  cursor: pointer;
  color: white;
}

#start {
  background: #777;
}
#strict {
  background: #555;
}
</style>
